import React, {useState} from 'react';

import styles from './Delivery.module.css'
import {deliveryIcon} from "../../assets/icons/icons.ts";
import {PickupPointModal} from "./components/PickupPointModal/PickupPointModal.tsx";
import {formatBranchName} from "../../utils/formatters/formatBranchName.ts";
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';


interface Props {
}

export const Delivery: React.FC<Props> = ({
                                          }) => {
    const {townId, branchId, branchTownId, branchAddress} = useAppSelector((state: RootState) => state.user.userInfo || {branchAddress: 'Владивосток', branchTownId: 1, townId: 1, branchId: 1});
    const [isOpen, setIsOpen] = useState<boolean>(false)
    
    const currentCity = formatBranchName('', {townId: townId ?? 1, point: {townId: branchTownId ?? 1, address: branchAddress ?? 'Владивосток'}});

    return (
        <>
            <PickupPointModal
                isOpen={isOpen}
                close={() => setIsOpen(false)}
                open={() => setIsOpen(true)}
                currentBranchAddress={currentCity}
                currentBranchId={branchId ?? 1}
                currentTownId={townId}
                forCart={false}
            />
            <a className={styles.delivery} onClick={() => setIsOpen(true)}>
                <img src={deliveryIcon} alt='Доставка'/>
                {currentCity}
            </a>
        </>
    );
};